// extracted by mini-css-extract-plugin
export var confirmation = "BaseForm-module--confirmation--5e4f1";
export var darkForm = "BaseForm-module--darkForm--4c04d BaseForm-module--form--4e890";
export var error = "BaseForm-module--error--c92c0";
export var errorMessage = "BaseForm-module--errorMessage--08eee";
export var fieldDescription = "BaseForm-module--fieldDescription--8f2a3";
export var form = "BaseForm-module--form--4e890";
export var formRowDouble = "BaseForm-module--formRowDouble--37617";
export var formRowDoubleReverse = "BaseForm-module--formRowDoubleReverse--191f5 BaseForm-module--formRowDouble--37617";
export var optInText = "BaseForm-module--optInText--66018";
export var passwordRow = "BaseForm-module--passwordRow--9acd6";
export var postFormText = "BaseForm-module--postFormText--d0739";
export var required = "BaseForm-module--required--888b6";
export var valid = "BaseForm-module--valid--66840";